/**
 * Scroll-reveal: fades sections' key elements up as they enter the
 * viewport. Applied entirely from JS so no-JS visitors (and crawlers)
 * always get fully visible content. Respects prefers-reduced-motion.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SELECTOR = [
    '.section-head',
    '.stats__item',
    '.testimonials__card',
    '.botanicals__card',
    '.trust-bar__item',
    '.faq__item',
    '.explainer__media',
    '.explainer__content',
    '.comparison__scroll',
    '.founder__content',
    '.cta-banner__inner',
    '.featured-product__card',
    '.product__reviews',
    '.contact__card',
    '.video-testimonials__card',
    '.story-card__card',
    '.info-cards__card',
    '.ingredient-list__card',
    '.blog__card'
  ].join(',');

  var els = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  if (!els.length) return;

  els.forEach(function (el) {
    var parent = el.parentElement;
    if (parent) {
      var peers = Array.prototype.filter.call(parent.children, function (c) {
        return c.matches && c.matches(SELECTOR);
      });
      var i = peers.indexOf(el);
      if (i > 0) el.style.setProperty('--reveal-delay', Math.min(i * 80, 400) + 'ms');
    }
    el.setAttribute('data-reveal', '');
  });

  function revealAll() {
    els.forEach(function (el) { el.classList.add('is-visible'); });
  }

  if (!('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var revealedAny = false;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        revealedAny = true;
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  els.forEach(function (el) { io.observe(el); });

  /* Safety net: if the observer never fires (unusual embedder, broken
     rendering context), show everything rather than leave content at
     opacity 0. Disarms itself the moment the first reveal happens. */
  function armFallback() {
    setTimeout(function () {
      if (!revealedAny) revealAll();
    }, 4000);
  }
  if (document.visibilityState === 'visible') {
    armFallback();
  } else {
    document.addEventListener('visibilitychange', function onVis() {
      if (document.visibilityState === 'visible') {
        document.removeEventListener('visibilitychange', onVis);
        armFallback();
      }
    });
  }
})();
